module.exports = __webpack_public_path__ + "../resources/img/ic_re_smartmodule.3958825b.svg";